export const LINE_MARKUP = "data-v-md-line";
export const HEADING_MARKUP = "data-v-md-heading";
export const ANCHOR_MARKUP = "data-v-md-anchor";
